/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Document_Source_LiveInputs */

const en_orders_document_source_live = /** @type {(inputs: Orders_Document_Source_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const es_orders_document_source_live = /** @type {(inputs: Orders_Document_Source_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En vivo`)
};

/**
* | output |
* | --- |
* | "Live" |
*
* @param {Orders_Document_Source_LiveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_document_source_live = /** @type {((inputs?: Orders_Document_Source_LiveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Document_Source_LiveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_document_source_live(inputs)
	return es_orders_document_source_live(inputs)
});